import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isDiscountInputValid } from 'utils/solaris/inputValidators';
import { calculateBenefits } from 'utils/solaris/energyBenefits';
import { fixDecimalString } from 'utils/numberUtils';
import config from 'utils/solaris/config';
import { formatMoneyWithCurrency } from 'utils/numberSplit';

import { SecondaryButton } from 'components/Buttons/Buttons';
import { StandardInput } from 'components/Inputs/Inputs';
import SolarisCalculatorResult from './SolarisCalculatorResult';

import styles from './EnergyBenefitsWidget.module.scss';

const EnergyBenefitsWidget = ({ onEnergyBenefitsClick = () => {} }) => {
  const { t } = useTranslation(['solaris']);
  const [benefits, setBenefits] = useState(null);

  const [amount, setAmount] = useState('');
  const handleAmountChange = (e) => {
    setError(null);
    setBenefits(null);
    setAmount(e.target.value);
  };

  const [error, setError] = useState(null);
  const showBenefits = () => {
    onEnergyBenefitsClick();
    const amountEntered = fixDecimalString(amount);
    const validationResult = isDiscountInputValid(amountEntered);
    if (validationResult.isValid) {
      setError(null);
      setBenefits(calculateBenefits(amountEntered));
    } else {
      if (validationResult.message === 'max-value')
        setError(
          t(`solaris:${validationResult.message}`, {
            max: formatMoneyWithCurrency(config.maxAmount, false),
          })
        );
      else setError('');
      setBenefits(null);
    }
  };

  return (
    <article className={styles.calculatorContainer}>
      <StandardInput
        name="amount"
        label={t('solaris:placeholders.monthly-discount')}
        maxLength={9}
        value={amount}
        error={error !== null}
        errorMessage={error}
        onChange={handleAmountChange}
        onKeyUp={(e) => {
          if (e.key === 'Enter' || e.keyCode === 13) showBenefits();
        }}
      />
      <SecondaryButton onClick={showBenefits}>
        {t('solaris:see-benefits')}
      </SecondaryButton>
      <SolarisCalculatorResult
        containerClass={styles.faded}
        label={t(`solaris:placeholders.yearly-discount`)}
        value={benefits?.yearlyDiscount}
      />
      <SolarisCalculatorResult
        containerClass={styles.faded}
        label={t(`solaris:placeholders.total-discount`, {
          years: config.sumMultiplier,
        })}
        value={benefits?.totalDiscount}
      />

      <SolarisCalculatorResult
        label={t(`solaris:placeholders.contribution`)}
        value={benefits?.contribution}
      />
      <p
        className={styles.info}
        dangerouslySetInnerHTML={{ __html: t(`solaris:info`) }}
      ></p>
    </article>
  );
};

export default EnergyBenefitsWidget;
